import classes from '~/config/classes'

export default class BeforeAndAfter extends HTMLElement {
  constructor() {
    super()
    this.debounce = false
    this.containerWidth = 0
    this.sliderWidth = 0
    this.sliderMargin = 0
    this.sliderWidthOffset = 0
    this.beforeElement = this.querySelector('.js-before')
    this.dragControl = this.querySelector('.js-before-drag-control')
    this.dragging = false

    this.initContainer()
    this.initDesktopEventHandlers()
    this.initMobileEventHandlers()
  }

  /**
   * Initialize
   */
  initContainer() {
    this.resizeObserver()
    this.classList.remove(classes.loading)
  }

  /**
   * Handle resize to update widths
   */
  resizeObserver() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.updateWidths(Math.floor(entry.contentRect.width))
      }
    })

    resizeObserver.observe(this)
  }

  /**
   * Update container and slider widths
   */
  updateWidths(width) {
    this.containerWidth = width
    this.style.setProperty('--image-width', `${this.containerWidth}px`)
    this.style.setProperty('--slider-width', `${this.containerWidth / 2}px`)

    if (window.innerWidth > this.containerWidth) {
      this.sliderWidthOffset = (window.innerWidth - this.containerWidth) / 2
    }
  }

  /**
   * Initialize desktop control mouse events
   */
  initDesktopEventHandlers() {
    this.dragControl.addEventListener('mousedown', () => {
      this.dragging = true
      this.dragControl.style.cursor = 'grabbing'
    })

    document.addEventListener('mouseup', () => {
      this.dragging = false
      this.dragControl.style.cursor = 'grab'
    })

    document.addEventListener('mousemove', (event) => {
      if (!event) {
        return
      }

      this.updateSliderWidth(event.pageX)
    })
  }

  /**
   * Initialize mobile control touch events
   */
  initMobileEventHandlers() {
    this.dragControl.addEventListener('touchstart', () => {
      this.dragging = true
    })

    this.dragControl.addEventListener('touchend', () => {
      this.dragging = false
    })

    this.dragControl.addEventListener('touchmove', (event) => {
      event.preventDefault()

      if (!event.targetTouches) {
        return
      }

      this.updateSliderWidth(event.targetTouches[0].pageX)
    })
  }

  /**
   * Update slider widths from control interactions
   * @param moveX - x position value to update
   */
  updateSliderWidth(moveX) {
    if (!this.dragging) {
      return
    }

    this.sliderWidth = moveX - this.sliderWidthOffset

    if (this.sliderWidth > this.sliderMargin &&
      this.sliderWidth < (this.containerWidth - this.sliderMargin)
    ) {
      this.style.setProperty('--slider-width', `${this.sliderWidth}px`)
    }
  }
}
